import { railIconButtonClassName } from "@/layouts/WorkspaceLayout/components/WorkspaceLeftRail/rail/railIconButtonClassName";
import { cn } from "@/utils";
import { Plus, type LucideIcon } from "lucide-react";

/** Compact header action in a rail section — matches dashboard-comp.
 *  Native `title` hint only: the rail doesn't do styled tooltips (the one
 *  Radix tooltip here was the rail's lone white bubble — Aug 2026). */
export function RailGroupActionButton({
  label,
  onClick,
  disabled,
  icon: Icon = Plus,
  ...buttonProps
}: {
  label: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  icon?: LucideIcon;
} & Omit<
  React.ComponentPropsWithoutRef<"button">,
  "type" | "aria-label" | "onClick" | "disabled" | "className" | "children"
>) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        railIconButtonClassName,
        disabled && "pointer-events-none opacity-50",
      )}
      {...buttonProps}
    >
      <Icon className="size-4" />
    </button>
  );
}
